// FinancialCalculatorsList.js
import React from 'react';
import { financialCalculators } from './ConstantsFinancialCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Kalkulator Keuangan - Kalkulator Gratis untuk Menghitung Pinjaman, Investasi, dan Transaksi Keuangan';
const DESCRIPTION = 'Jelajahi kumpulan kalkulator keuangan gratis, termasuk kalkulator pinjaman, investasi, dan transaksi keuangan.';
const KEYWORDS = 'kalkulator keuangan, kalkulator gratis, kalkulator pinjaman, kalkulator investasi, kalkulator transaksi keuangan';
const OG_URL = 'https://do-calculate.com/id/financial-calculators';
function CalculatorsList() {
    return (
      <div>
        <div className="container ">
          <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
          <div>
            <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
            <hr />
            <div className="alert alert-secondary" role="alert">
              <p>{DESCRIPTION} </p>
            </div>
          </div>
          <hr />
          <table >
            <thead>
              <tr>
                <th >Kalkulator</th>
                <th >Deskripsi</th>
              </tr>
            </thead>
            <tbody>
              {financialCalculators.map((calculator, index) => (
                <tr key={index}>
                  <td>
                    <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                  </td>
                  <td><p>{calculator.description}</p></td>
                </tr>
              ))}
            </tbody>
           </table>
          <br />
        </div>
      </div>
    );
  }
export default CalculatorsList;